// axiosInstance.js
import axios from "axios";
import Swal from "sweetalert2";
import { BASE_URL_AXIOS } from "../../appConstants";
import "./swalalert.css";

const axiosInstance = axios.create({
  baseURL: BASE_URL_AXIOS,
});
// Add a response interceptor
const handleButtonClick = () => {
  window.location.href = "/login";
};

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      ((error.response && error.response.status === 401) ||
        (error.response && error.response.status === 403)) &&
      window.location.pathname !== "/login" &&
      window.location.pathname !== "/"
    ) {
      if (window.location.pathname === "/update-password") {
        return;
      }
      Swal.fire({
        title: "Your Session Has Expired",
        html: `
          <p> Login Again.</p>
        `,

        customClass: {
          container: "swal-container",
          popup: "swal-popup",
          header: "swal-header",
          title: "swal-title",
          closeButton: "swal-close-button",
          htmlContainer: "swal-html-container",
          icon: "swal-icon",
          image: "swal-image",
          content: "swal-content",
          input: "swal-input",
          actions: "swal-actions",
          confirmButton: "swal-button swal-button-confirm",
          footer: "swal-footer",
        },
        background: "#1a2c2b",
        allowOutsideClick: false,
        backdrop: "rgba(0,0,0,0.3)",
        allowOutsideClick: false,
        confirmButtonText: "Login",
        preConfirm: () => {
          handleButtonClick();
          return false;
        },
      });
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
